import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftHistoryServer } from "namirasoft-history";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { HistoryLayout } from "./HistoryLayout";
import { HistoryRoutes } from "./HistoryRoutes";
import HistoryListPage from "./pages/HistoryListPage";
import HistoryViewPage from "./pages/HistoryViewPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_HISTORY}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_HISTORY = new EnvService("REACT_APP_BASE_URL_HISTORY", true).getString();
            let history = new NamirasoftHistoryServer(REACT_APP_BASE_URL_HISTORY, result.account.token_manager, result.notifier.onError);
            let servers = { history };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows => (<Routes>
                        <Route path={HistoryRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                        <Route path={HistoryRoutes.HistoryList} element={<HistoryListPage {...result} servers={servers} />} />
                        <Route path={HistoryRoutes.HistoryView(":id")} element={<HistoryViewPage {...result} servers={servers} />} />

                        {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                        <Route path="*" element={<NSNotFoundPage />} />
                    </Routes >))}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={HistoryRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <HistoryLayout
                {...props}
            >
                {props.children}
            </HistoryLayout>
        )}
        requirement={{
            verification: {
                email: false,
                phone: false
            }
        }}
    />
}

export default Router;